document.addEventListener('DOMContentLoaded', () => {
  const map = document.querySelector('.map-locations');
  const mapWidth = 1592;
  const sprites = [];
  if (map) {
    const markers = JSON.parse(
      decodeURIComponent(map.getAttribute('data-markers'))
    );

    markers.forEach((marker, idx) => {
      sprites.push(elementFactory(map, marker, idx));
    });

    calculateMarkerPosition(map, sprites);
    window.addEventListener('resize', () =>
      calculateMarkerPosition(map, sprites)
    );

    const mapObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          sprites.forEach(sprite => {
            sprite.element.style.opacity = 1;
          });
        }
      });
    });

    mapObserver.observe(map);
  }
  function elementFactory(container, props, idx) {
    const { top, left, pos, title } = props;
    const element = document.createElement('div');
    element.classList.add('marker');

    element.style.top = `${top}px`;
    element.style.left = `${left}px`;

    element.style.opacity = 0;

    element.style.transition = `opacity 400ms ease ${idx * 200 + 600}ms `;
    const label = document.createElement('div');
    label.textContent = title;
    label.classList.add(`marker-label`);
    label.classList.add(`marker-label-${pos}`);
    element.appendChild(label);

    container.prepend(element);
    return { container, ...props, element };
  }

  function calculateMarkerPosition(container, items) {
    const ratio = container.offsetWidth / mapWidth;

    items.forEach(item => {
      item.element.style.top = `${parseInt(item.top) * ratio}px`;
      item.element.style.left = `${parseInt(item.left) * ratio}px`;
      item.element.style.width = `${25 * ratio}px`;
      item.element.style.height = `${25 * ratio}px`;
      item.element.style.fontSize = `${21 * ratio}px`;

      label = item.element.querySelector('.marker-label');
      switch (item.pos) {
        case 'top-left':
          label.style.top = `${-18 * ratio}px`;
          label.style.left = `${-200 * ratio}px`;
          label.style.width = `${200 * ratio}px`;
          break;
        case 'top-right':
          label.style.top = `${-18 * ratio}px`;
          label.style.right = `${-30 * ratio}px`;
          break;
        case 'bottom-left':
          label.style.bottom = `${-10 * ratio}px`;
          label.style.left = `${-200 * ratio}px`;
          label.style.width = `${200 * ratio}px`;
          break;
        case 'bottom-right':
          label.style.bottom = `${-10 * ratio}px`;
          label.style.right = `${-30 * ratio}px`;
          break;
      }
    });
  }
});
